import script from "./BEndComponentLocal.vue?vue&type=script&setup=true&lang=js"
export * from "./BEndComponentLocal.vue?vue&type=script&setup=true&lang=js"

import "./BEndComponentLocal.vue?vue&type=style&index=0&id=6575d466&lang=scss"

const __exports__ = script;

export default __exports__